import React from 'react'
import ColorPalette from './ColorPalette'
import ToolSelector from './ToolSelector'
import BrushSettings from './BrushSettings'
import styles from './ToolPanel.module.css'

const ToolPanel = () => {
  return (
    <div className={styles.toolPanel}>
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>색상</h3>
        <ColorPalette />
      </div>
      
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>설정</h3>
        <BrushSettings />
      </div>
    </div>
  )
}

export default ToolPanel